export var PlayersSortTypes;
(function (PlayersSortTypes) {
    PlayersSortTypes["ascending"] = "ascending";
    PlayersSortTypes["descending"] = "descending";
})(PlayersSortTypes || (PlayersSortTypes = {}));
export var PlayersResultTypes;
(function (PlayersResultTypes) {
    PlayersResultTypes["time"] = "time";
    PlayersResultTypes["metersPoints"] = "metersPoints";
    PlayersResultTypes["points"] = "points";
    PlayersResultTypes["meters"] = "meters";
})(PlayersResultTypes || (PlayersResultTypes = {}));
export var PlayersSecondResultTypes;
(function (PlayersSecondResultTypes) {
    PlayersSecondResultTypes["none"] = "none";
    PlayersSecondResultTypes["number"] = "number";
    PlayersSecondResultTypes["numberArray"] = "numberArray";
})(PlayersSecondResultTypes || (PlayersSecondResultTypes = {}));
//# sourceMappingURL=players.js.map